import api from 'common/api';

export const getDeliveryDestAPI = (params: any) => api.get('/delivery-dest-master/list', params);

export const getDeliveryDestDetailAPI = (params: any) => api.get('/delivery-dest-master/detail', params);

export const addDeliveryDestAPI = (params: any) => api.post('/delivery-dest-master', params);

export const updateDeliveryDestAPI = (params: any) => api.put('/delivery-dest-master', params);

export const deleteDeliveryDestAPI = (params: any) => api.put('/delivery-dest-master/delete', params);

export const DOWNLOAD_EXCEL_DELIVERY_DEST_MAST = '/delivery-dest-master/list';
